import { render, staticRenderFns } from "./SubmitOrder.vue?vue&type=template&id=f485c31e"
import script from "./SubmitOrder.vue?vue&type=script&lang=js"
export * from "./SubmitOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports